import { render, staticRenderFns } from "./BasicLayout.vue?vue&type=template&id=401bf89c&scoped=true&"
import script from "./BasicLayout.vue?vue&type=script&lang=js&"
export * from "./BasicLayout.vue?vue&type=script&lang=js&"
import style0 from "./BasicLayout.vue?vue&type=style&index=0&lang=less&"
import style1 from "./BasicLayout.vue?vue&type=style&index=1&id=401bf89c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401bf89c",
  null
  
)

export default component.exports